/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RatingStatus {
    URN_FLUX_RATING_REQUEST_STATUS_IN_PROGRESS = 'urn:flux:rating:request:status:in-progress',
    URN_FLUX_RATING_REQUEST_STATUS_COMPLETED = 'urn:flux:rating:request:status:completed',
    URN_FLUX_RATING_REQUEST_STATUS_FAILED = 'urn:flux:rating:request:status:failed',
}
